import styled from '@emotion/styled';

export const InputContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	div {
		font-size: var(--paragraph3-font-size);
		span#placeholder {
			font-weight: 200;
		}
		> div {
			flex-direction: row;
		}
	}
	max-width: 100%;
	padding: 0 0.3rem 0 1.2rem;
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
	background: ${({ disabled }) => (disabled ? 'var(--input-disabled-bg-color)' : 'var(--input-bg-color)')};
	color: ${({ disabled }) => (disabled ? 'var(--content-4)' : 'var(--secondaryColor)')};
	pointer-events: ${({ disabled }) => (disabled ? 'none' : 'unset')};
	min-height: 4.5rem;

	img {
		height: 100%;
		width: 6rem;
	}

	input[type='file'] {
		display: none;
		z-index: var(--z-index-1);

		:-webkit-file-upload-button {
			visibility: hidden;
		}
	}

	body[dir='rtl'] & {
		min-height: 5.5rem;
	}
`;

export const FileInputFlexRow = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	max-width: 100%;

	span.fileName {
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
		width: 35rem;
	}
	img {
		justify-content: center;
		width: auto;
		cursor: pointer;
	}
	> label {
		padding: var(--buttonSmallPadding);
	}
`;

export const FlexRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	max-width: 100%;

	span.fileName {
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
		width: 35rem;
	}
	img {
		justify-content: center;
		width: auto;
		cursor: pointer;
	}
	> label {
		padding: var(--buttonSmallPadding);
	}
`;

export const LoadingContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;
